<template>
    <div class="budgetary-legitimations" v-if="showTariff">
        <button class="float-right btn btn-outline-primary btn-sm pb-30-sm" @click="resetTariff">Restablecer</button>

        <form v-on:submit.prevent style="clear:both">
            <numeric-question v-model="numberOfDocuments" :min="1" @input="resetDocuments">
                ¿Cuántos documentos quieres legitimar?

                <legitimation-document slot="single" ref="document" @updated="update"
                                       :has-international-document.sync="hasInternationalDocument"></legitimation-document>

                <assertive-question slot="multiple" v-if="numberOfDocuments" v-model="singleSignature" @input="resetDocuments">
                    ¿Todos los documentos los firma una sola persona?

                    <assertive-question slot="answered" v-model="cloneDocuments">
                        ¿Todos los documentos son iguales?

                        <legitimation-document slot="afirmative" ref="document" :singleSignature="singleSignature"
                                               @updated="update" :has-international-document.sync="hasInternationalDocument"></legitimation-document>

                        <accordion class="mb-4"
                                   slot="negative"
                                   v-for="n in numberOfDocuments"
                                   :key="n"
                                   dynamic-content
                                   :dynamicRefreshTime="50">
                            <strong slot="title" class="mr-4">Documento {{ n }}</strong>
                            <small slot="title" class="mr-auto ml-4"></small>
                            <legitimation-document ref="document" :singleSignature="singleSignature"
                                                   @updated="update" :has-international-document.sync="hasInternationalDocument"></legitimation-document>
                        </accordion>

                    </assertive-question>
                </assertive-question>

            </numeric-question>
            <keep-alive>
                <assertive-question v-if="readyToCalculate" v-model="isCompany" afirmativeLabel="Empresa"
                                    negativeLabel="Particular" @input="calculate">
                    ¿La factura debe emitirse a nombre de empresa o particular?
                </assertive-question>
            </keep-alive>
        </form>

        <budget-summary v-if="readyToCalculate && cost" 
                        :cost="cost"
                        :honoraries="honoraries"
                        :apostilles="apostilles"
                        :retention="isCompany" 
                        :untaxedCosts="untaxedCosts"
                        service="legitimations"
                        :delivery-cost="deliveryCost">
            <slot name="callToActions"></slot>

        </budget-summary>

    </div>
</template>

<script>
    export default {

        data: function () {
            return {
                showTariff: true,

                cost: 0,
                untaxedCosts: 0,
                honoraries: 0,
                apostilles: 0,

                numberOfDocuments: null,
                singleSignature: null,
                cloneDocuments: null,
                isCompany: null,

                readyToCalculate: false,

                foliosNumber: 0,
                simpleCopiesNumber: 1,
                authorizedCopiesNumber: 1,

                hasInternationalDocument: false,
                deliveryCost: 0
            }
        },

        methods: {
          resetTariff: function () {
            this.showTariff = false
            this.$nextTick(function () {
              this.showTariff = true
            })
          },
            update: function (completed) {
                this.$nextTick(() => {
                    this.readyToCalculate = this.isReadyToCalculate(completed);

                    if (this.readyToCalculate && this.isCompany != null) this.calculate();
                });
            },
            calculate: function () {
                this.cost = this.honoraries = this.untaxedCosts = this.foliosNumber = 0;

                let isAct = this.isActRequired();

                if (isAct) {
                    // Importe base del Acta 207 y actos complementarios.
                    this.cost = 36.06; // + 11.36; //36.06 + 11.36;
                    this.honoraries = 36.06
                    // Si es empresa, sumar coste de titular real y consulta mercantil.
                    if (this.isCompany) {
                        this.cost += 0.24 + 3;
                        this.honoraries += 0.24 + 3;
                    }
                }

                if (this.$refs.document instanceof Vue) {
                    this.cost += this.$refs.document.cost * this.numberOfDocuments;
                    this.honoraries += this.$refs.document.cost * this.numberOfDocuments;
                    this.untaxedCosts += this.$refs.document.untaxedCosts * this.numberOfDocuments;
                    this.foliosNumber += this.$refs.document.foliosNumber * this.numberOfDocuments;

                } else if (this.$refs.document instanceof Array) {

                    _.forEach(this.$refs.document, (legitimationDocument) => {
                        this.cost += legitimationDocument.cost;
                        this.honoraries += legitimationDocument.cost;
                        this.untaxedCosts += legitimationDocument.untaxedCosts;
                        this.foliosNumber += legitimationDocument.foliosNumber;
                    });

                } else {
                    console.log('LegitimationsBudgetary: exception on calculate()');
                }

                if (isAct) {

                    // Se deben añadir 2 folios del modelo de acta a los indicados.
                    this.foliosNumber += 2;

                    // Sumar coste por folio, sólo a partir del quinto. Los 4 primeros no se cobran.
                    if (this.foliosNumber >= 5) {
                        this.cost += (this.foliosNumber - 4) * (1000 / 166.386);
                        this.honoraries += (this.foliosNumber - 4) * (1000 / 166.386);
                    }

                    // Sumar coste de copias autorizadas. Se añade 1 folio a los indicados.
                    let authorizedCopiesFoliosNumber = this.foliosNumber + 1;
                    let totalFoliosCost = authorizedCopiesFoliosNumber * (500 / 166.386);
                    // A partir del duodécimo folio, cada folio cuesta la mitad. El descuento no se aplica los primeros 11 folios.
                    if (authorizedCopiesFoliosNumber >= 12) {
                        totalFoliosCost -= (authorizedCopiesFoliosNumber - 11) * (250 / 166.386);
                    }
                    this.cost += totalFoliosCost * this.authorizedCopiesNumber;
                    this.honoraries += totalFoliosCost * this.authorizedCopiesNumber;

                    //Costo de apostillas
                    this.apostilles += this.untaxedCosts

                    //Costo de honorarios
                    this.honoraries += (((this.foliosNumber) * (100 / 166.386)) * this.simpleCopiesNumber)

                    // Sumar coste de copias simples.
                    this.cost += (((this.foliosNumber) * (100 / 166.386)) * this.simpleCopiesNumber) + this.untaxedCosts

                    // Sumar costo de mensajería
                    this.honoraries += this.hasInternationalDocument ? 7 : 0
                    this.cost += this.hasInternationalDocument ? 7 : 0

                    // Sumar el coste de los folios suplidos.
                    this.untaxedCosts = (this.authorizedCopiesNumber * (this.foliosNumber + 1) + (this.foliosNumber)) * 0.15;

                    this.deliveryCost = this.hasInternationalDocument ? 7 : 0
                }
            },
            isReadyToCalculate: function (documentCompleteStatus) {

                if (documentCompleteStatus === false) return false;

                if (this.numberOfDocuments === 1) return documentCompleteStatus;

                if (this.numberOfDocuments > 1) {

                    if (this.singleSignature == null) return false;

                    if (this.cloneDocuments == null) return false;
                    if (this.cloneDocuments) return documentCompleteStatus;

                    return this.areAllDocumentsCompleted(this.$refs.document);
                }
            },
            areAllDocumentsCompleted: function (documents) {

                let allDocumentsCompleted = null;

                _.forEach(documents, (doc) => {
                    allDocumentsCompleted = doc.completed;
                    if (doc.completed === false) return false;
                });

                return !!allDocumentsCompleted;
            },
            isActRequired: function () {

                if (this.$refs.document instanceof Vue) {
                    return this.$refs.document.requiresAct;
                } else if (this.$refs.document instanceof Array) {
                    return _.some(this.$refs.document, ['requiresAct', true]);
                }

                return false;
            },
            getJSON: function () {
                let json = [];
                json.push({
                    name: 'Tipo',
                    value: 'Legitimiaciones'
                });

                json.push({
                    "name": "¿Cuántos documentos quieres legitimar?",
                    "value": this.numberOfDocuments
                });

                if (this.numberOfDocuments === 1) {
                    json = json.concat(this.$refs.document.getJSON());
                } else {
                    json.push({
                        "name": "¿Todos los documentos los firma una sola persona?",
                        "value": this.singleSignature
                    });

                    json.push({
                        "name": "¿Todos los documentos son iguales?",
                        "value": this.cloneDocuments
                    });

                    if (this.cloneDocuments) {
                        json = json.concat(this.$refs.document.getJSON());
                    } else {
                        json.push(this.getDocumentJSONArray(this.$refs.document));
                    }
                }

                json.push({
                    "name": "¿La factura debe emitirse a nombre de empresa o particular?",
                    "value": this.isCompany ? 'Empresa' : 'Particular'
                });

                return json;
            },
            getDocumentJSONArray: function (documents) {
                let array = [];
                let index = 0;
                _.forEach(documents, (doc) => {
                    index++;
                    array.push({
                        "name": "Documento " + index,
                        "value": doc.getJSON()
                    });
                });
                return {
                    "name": "Documentos:",
                    "value": array
                }
            },
            resetDocuments: function () {
                this.readyToCalculate = false
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../../sass/variables";

    @media (max-width: 540px) {
        .budgetary-legitimations {
            padding-bottom: 80px;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/budgetary/legitimations/LegitimationsBudgetary.vue